
<template lang="html">


    <!-- Sidebar -->
    <!--  -->
    <div class="border-right" id="sidebar-wrapper" >
      <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt="" width="200" />
      </div>
      <div class="list-group list-group-flush pl-4 pr-4">
        <h5 class="mb-0">Filter By</h5>
        <hr> 
          <h6> Thematic Area</h6>
          
       <selectize v-model="selected"  :settings="settings"> <!-- settings is optional -->
          <option :value="1">One</option>
          <option :value="2">Two</option>
          <option :value="3">Three</option>
        </selectize>
        <hr>
         <div class="row">
         <div class="col-sm-12">
           <h6 class="label-control">Start Date</h6>
           <input type="date" class="form-control">
           </div>
            <div class="col-sm-12 mt-3">
              <h6 class="label-control">End Date</h6>
           <input type="date" class="form-control">
           </div>
           </div>
        
      
        <hr style="margin-bottom:25rem">
       </div>
    </div>
</template>

<script>
import Selectize from "vue2-selectize";
export default {
  data: () => ({
    active: true,
    isFilter: false,
    basepath :localStorage.getItem("BASE_PATH"),
    selected: "",
    settings: {
      maxItems: 3,
      plugins: ["remove_button"],
      delimiter: "|"
    }
  }),
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = data;
    // });
  },
  components: {
    Selectize,
  },
  methods: {
    updateRanges: function() {
    
    }
    // isSidebar() {
    //   bus.$emit("sidebarStatus", this.active);
    // }
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */
.vs-collapse {
  padding: 0px !important;
}
.vs-collapse-item--header {
  padding: 0px !important;
}
</style>

<style scoped>
.con-vs-checkbox {
  justify-content: start;
}
 /* #sidebar-wrapper{
    height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index:10;
    position: fixed;
 } */
 
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */

@media print {
  #sidebar-wrapper {
    display: none;
  }
}
</style>